import React, { Component } from 'react';
import { Route, Switch, BrowserRouter as Router } from 'react-router-dom';
import Login from './views/Login';
import Dashboard from './views/Dashboard';
import DefaultEntities from './views/Defaults';
import UserDataPage from './views/UserData';
import PrivateRoute from './components/PrivateRoute';
import PublicRoute from './components/PublicRoute';
import ResetPassword from './views/NewPassword';
import './scss/style.scss';
import Categories from './views/Categories';
import Brands from './views/Brands';
import Users from './views/Users';
import VoteAndFeedbacks from './views/Votes_Feedbacks';

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
);

// Containers
const TheLayout = React.lazy(() => import('./containers/TheLayout'));

class App extends Component {
  render() {
    return (
      <Router>
        <React.Suspense fallback={loading}>
          <Switch>
            <Route
              path="/resetPassword"
              render={(props) => <ResetPassword {...props} />}
            />
            <PublicRoute path="/" name="Login" exact>
              <Login />
            </PublicRoute>
            <PrivateRoute path="/dashboard" name="Dashboard">
              <TheLayout>
                <Dashboard />
              </TheLayout>
            </PrivateRoute>
            <PrivateRoute path="/defaults" name="Default Entites">
              <TheLayout>
                <DefaultEntities />
              </TheLayout>
            </PrivateRoute>
            <PrivateRoute path="/categories" name="Categories">
              <TheLayout>
                <Categories />
              </TheLayout>
            </PrivateRoute>
            <PrivateRoute path="/brands" name="Brands">
              <TheLayout>
                <Brands />
              </TheLayout>
            </PrivateRoute>
            <PrivateRoute path="/users" name="Users">
              <TheLayout>
                <Users />
              </TheLayout>
            </PrivateRoute>
            <PrivateRoute path="/votes-feedbacks" name="Votes & Feedbacks">
              <TheLayout>
                <VoteAndFeedbacks />
              </TheLayout>
            </PrivateRoute>
            <PrivateRoute path="/brands-comparision" name="Brands Comparision">
              <TheLayout>
                <VoteAndFeedbacks />
              </TheLayout>
            </PrivateRoute>
          </Switch>
        </React.Suspense>
      </Router>
    );
  }
}

export default App;
